import React, { useEffect, useState } from "react";

function calcularSemaforo(resultados) {
  if (!resultados?.ranking?.length) return null;
  const mejorAhorro = resultados.ranking[0].ahorro;
  const importe = resultados.datos_extraidos?.importe;
  if (!importe || importe <= 0) return null;
  const pct = (mejorAhorro / importe) * 100;
  if (pct > 15) return "rojo";
  if (pct >= 5) return "amarillo";
  return "verde";
}

const CONFIG = {
  rojo: {
    color: "#ff4444",
    glow: "rgba(255,68,68,.35)",
    emoji: "🔴",
    titulo: "¡Tu factura tiene mucho margen de mejora!",
    mensaje: "Estás pagando más de lo necesario. Hay tarifas en el mercado que podrían reducir significativamente tu factura cada mes. ¡Descubre cuánto puedes ahorrar!",
    cta: "Ver qué tarifas te ahorran más →",
  },
  amarillo: {
    color: "#f5a623",
    glow: "rgba(245,166,35,.35)",
    emoji: "🟡",
    titulo: "Tu tarifa tiene potencial de mejora",
    mensaje: "Existen tarifas que se ajustan más a tu consumo y podrían ahorrarte algo cada mes. ¡Descubre cuánto puedes ahorrar!",
    cta: "Ver las alternativas disponibles →",
  },
  verde: {
    color: "#00e5a0",
    glow: "rgba(0,229,160,.35)",
    emoji: "🟢",
    titulo: "Tu tarifa es bastante competitiva",
    mensaje: "Estás en una buena tarifa, pero el mercado energético cambia constantemente. Comparar podría asegurarte elegir la mejor opción. ¡Descubre cuánto puedes ahorrar!",
    cta: "Ver igualmente la comparativa →",
  },
};

export default function Paso3Semaforo({ resultados, onSiguiente }) {
  const nivel = calcularSemaforo(resultados);
  const [visible, setVisible] = useState(false);
  const [luzActiva, setLuzActiva] = useState(null);

  useEffect(() => {
    // Animación de entrada
    setTimeout(() => setVisible(true), 100);
    // Encender la luz con delay para efecto dramático
    setTimeout(() => setLuzActiva(nivel), 800);
  }, [nivel]);

  if (!nivel) {
    onSiguiente();
    return null;
  }

  const cfg = CONFIG[nivel];
  const mejorAhorro = resultados.ranking[0]?.ahorro;

  return (
    <div style={{
      opacity: visible ? 1 : 0,
      transform: visible ? "translateY(0)" : "translateY(20px)",
      transition: "all 0.5s ease",
    }}>
      {/* CABECERA */}
      <div style={{ textAlign: "center", marginBottom: 40 }}>
        <div style={{
          display: "inline-block", fontFamily: "var(--mono)", fontSize: 11,
          color: "var(--accent)", border: "1px solid rgba(245,166,35,.3)",
          borderRadius: 99, padding: "4px 14px", marginBottom: 16, letterSpacing: "0.1em",
        }}>
          SALUD ENERGÉTICA
        </div>
        <h2 style={{
          fontFamily: "var(--display)", fontSize: "clamp(22px, 4vw, 36px)",
          fontWeight: 800, letterSpacing: "-0.03em", lineHeight: 1.1, marginBottom: 12,
        }}>
          ¿Cuál es el estado de tu<br />
          <span style={{ color: "var(--accent)" }}>salud energética?</span>
        </h2>
        <p style={{ color: "var(--text2)", fontSize: 15, maxWidth: 480, margin: "0 auto" }}>
          Hemos analizado tu factura y comparado con todas las tarifas del mercado.
        </p>
      </div>

      {/* SEMÁFORO */}
      <div className="card" style={{ maxWidth: 480, margin: "0 auto 32px", textAlign: "center" }}>
        {/* Carcasa del semáforo */}
        <div style={{
          display: "inline-flex", flexDirection: "column", alignItems: "center",
          gap: 16, background: "#0a0f18", border: "2px solid rgba(255,255,255,.1)",
          borderRadius: 20, padding: "28px 40px", marginBottom: 28,
          boxShadow: luzActiva ? `0 0 60px ${CONFIG[luzActiva].glow}` : "none",
          transition: "box-shadow 0.8s ease",
        }}>
          {/* Título semáforo */}
          <div style={{
            fontFamily: "var(--mono)", fontSize: 10, color: "rgba(255,255,255,.4)",
            letterSpacing: "0.15em", textTransform: "uppercase",
          }}>
            SALUD ENERGÉTICA
          </div>

          {/* Las tres luces */}
          {["rojo", "amarillo", "verde"].map((color) => (
            <div key={color} style={{
              width: 80, height: 80, borderRadius: "50%",
              background: luzActiva === color
                ? CONFIG[color].color
                : "rgba(255,255,255,.06)",
              border: `2px solid ${luzActiva === color ? CONFIG[color].color : "rgba(255,255,255,.1)"}`,
              boxShadow: luzActiva === color
                ? `0 0 30px ${CONFIG[color].glow}, 0 0 60px ${CONFIG[color].glow}`
                : "none",
              transition: "all 0.6s ease",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: luzActiva === color ? 32 : 0,
            }}>
              {luzActiva === color && (color === "rojo" ? "🔴" : color === "amarillo" ? "🟡" : "🟢")}
            </div>
          ))}
        </div>

        {/* Mensaje */}
        {luzActiva && (
          <div style={{
            opacity: luzActiva ? 1 : 0,
            transform: luzActiva ? "translateY(0)" : "translateY(10px)",
            transition: "all 0.5s ease 0.3s",
          }}>
            <h3 style={{
              fontFamily: "var(--display)", fontSize: 20, fontWeight: 800,
              color: cfg.color, marginBottom: 12, letterSpacing: "-0.02em",
            }}>
              {cfg.titulo}
            </h3>
            <p style={{
              color: "var(--text2)", fontSize: 14, lineHeight: 1.7,
              marginBottom: 20, maxWidth: 380, margin: "0 auto 20px",
            }}>
              {cfg.mensaje}
            </p>


          </div>
        )}

        {/* Botón */}
        <button
          className="btn btn-primary"
          onClick={onSiguiente}
          style={{ marginTop: 8 }}
        >
          {cfg.cta}
        </button>

        {/* Aviso */}
        <div style={{
          marginTop: 20, padding: "10px 14px",
          background: "rgba(245,166,35,.06)", border: "1px solid rgba(245,166,35,.2)",
          borderRadius: 8, fontSize: 12, color: "var(--text2)", lineHeight: 1.6, textAlign: "left",
        }}>
          ⚠ <strong style={{ color: "var(--text)" }}>Aviso importante</strong> — Los costes mostrados son estimaciones orientativas basadas en tu potencia contratada y consumo por periodos. El coste real puede variar según descuentos, bono social, alquiler de contador u otros servicios adicionales.
        </div>
      </div>
    </div>
  );
}
